import {Dialog} from "primereact/dialog";
import {ResponsiveDataTable} from "../../components/ResponsiveDataTable";
import {Column} from "primereact/column";
import {Button} from "primereact/button";
import React, {useEffect, useRef, useState} from "react";
import {Toast} from "primereact/toast";
import {GiftService} from "./GiftService";
import {handleError} from "../../service/HandleErrorService";
import {InputText} from "primereact/inputtext";
import {Dropdown} from "primereact/dropdown";
import {useHistory} from "react-router-dom";
import moment from "moment";


const LastGiftView = () => {
  const history = useHistory();
  const [totalApproveScore, setTotalApproveScore] = useState(0);
  const [totalRejectScore, setTotalRejectScore] = useState(0);
  const [totalWaitingScore, setTotalWaitingScore] = useState(0);

  const [allGifts, setAllGifts] = useState([]);
  const [paginationConfig, setPaginationConfig] = useState({
    itemsPerPage: 10,
    first: 0,
    totalRecords: 30,
    activePage: 0,
  });
  const [allGiftTransactionType, setAllGiftTransactionType] = useState([]);
  const resellerCode = JSON.parse(localStorage.getItem('user')).user?.loginReseller?.code;
  const resellerName = JSON.parse(localStorage.getItem('user')).user?.loginReseller?.name;
  const [lastGiftDialog, setLastGiftDialog] = useState(false);
  const giftService = new GiftService();
  const toast = useRef(null);
  const [searchRequest, setSearchRequest] = useState({});
  const [loading, setLoading] = useState(false);
  const [editImages, setEditImages] = useState([]);
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [currentGift, setCurrentGift] = useState({});
  const [viewImageDialog, setViewImageDialog] = useState(false);
  const [exportExcelDisabled, setExportExcelDisabled] = useState(false);
  useEffect(() => {

    getAll({activePage: paginationConfig.activePage, itemsPerPage: paginationConfig.itemsPerPage})
  }, [searchRequest]);

  useEffect(() => {
    giftService.getGiftTransactionType().then(res => {

      setAllGiftTransactionType(res)
    }).catch(err => handleError(err, toast))
  }, []);

  const getAll = (pageState) => {
    let _searchRequest = {...searchRequest};

    var sort = "";
    if (_searchRequest.sortField != null && _searchRequest.sortOrder != null) {
      sort += _searchRequest.sortField;
      if (_searchRequest.sortOrder === 1) {
        sort += ",asc";
      } else {
        sort += ",desc";
      }
    } else {
      sort = "createDateTime,desc";
    }
    setLoading(true);
    _searchRequest.resellerCode = resellerCode + resellerName;
    giftService.getMyGift(_searchRequest, pageState.itemsPerPage, pageState.activePage, sort).then(res => {
      pageState.first = pageState.itemsPerPage * pageState.activePage;
      pageState.totalRecords = res.totalElements;
      setPaginationConfig({
        ...pageState,
      });

      let _totalApproveScore = 0;
      let _totalWaitingScore = 0;
      setAllGifts(res.content);
      res?.content?.forEach(value => {
        if (value.giftTransactionType === 'APPROVED_TO_REQUEST') {
          _totalApproveScore += value?.gift?.giftScore;
        } else if (value?.giftTransactionType === 'WAITING_FOR_RESPONSE') {
          _totalWaitingScore += value?.gift?.giftScore;
        }
      });

      setTotalWaitingScore(_totalWaitingScore)
      setTotalApproveScore(_totalApproveScore);

    }).catch(err => handleError(err, toast))
      .finally(() => setLoading(false));


  }

  const onActivePageChange = (e) => {
    let pageState = {
      ...paginationConfig,
      itemsPerPage: e.rows,
      activePage: e.page,
    };
    getAll(pageState);
  };
  const onSort = (e) => {
    let _lazyParams = {...searchRequest, ...e};
    setSearchRequest(_lazyParams);
  };
  const requesterFilterRender = () => {
    return (
      <InputText placeholder="Ara" value={searchRequest?.requesterName} onChange={e => {
        let _request = {...searchRequest};
        _request.requesterName = e.target.value
        setSearchRequest(_request);
      }} className="p-column-filter"/>

    )
  }

  const currentTypeFilterRender = () => {
    return (
      <Dropdown value={searchRequest?.giftTransactionType}
                options={allGiftTransactionType}
                optionValue="key"
                showClear
                placeholder="Ara"
                optionLabel="value"
                onChange={e => {
                  let _request = {...searchRequest};
                  _request.giftTransactionType = e.target.value
                  setSearchRequest(_request);
                }} className="p-column-filter"/>

    )
  }
  const nameFilterRender = () => {
    return (
      <InputText placeholder="Ara" className="p-column-filter" value={searchRequest?.giftName} onChange={e => {
        let _request = {...searchRequest};
        _request.giftName = e.target.value
        setSearchRequest(_request);
      }}/>

    )
  }
  const barcodeFilterRender = () => {
    return (
      <InputText placeholder="Ara" className="p-column-filter" value={searchRequest?.giftBarcode} onChange={e => {
        let _request = {...searchRequest};
        _request.giftBarcode = e.target.value
        setSearchRequest(_request);
      }}/>

    )
  }
  const codeFilterRender = () => {
    return (
      <InputText placeholder="Ara" className="p-column-filter" value={searchRequest?.code} onChange={e => {
        let _request = {...searchRequest};
        _request.code = e.target.value
        setSearchRequest(_request);
      }}/>

    )
  }
  const requesterFilter = requesterFilterRender();
  const currentTypeFilter = currentTypeFilterRender();

  const nameFilter = nameFilterRender();
  const barcodeFilter = barcodeFilterRender();
  const codeFilter = codeFilterRender();
  const requesterTemplate = (rowData) => {
    return (
      <div>
        {rowData.requester?.name + " " + rowData.requester?.surname}
      </div>
    )
  }
  const giftTransactionTemplate = (rowData) => {
    let _allGiftTransactionType = [...allGiftTransactionType];
    let _response = _allGiftTransactionType.find(gift => gift.key === rowData.giftTransactionType);

    return (
      <div>{_response?.value}</div>

    )
  }

  const imageTemplate = (rowData) => {

    return (
      <img style={{height:"auto",width:'100%'}} src={rowData.publicAddress}/>
    )
  }

  const exportExcel = () => {
    setExportExcelDisabled(true);
    let _searchRequest = {...searchRequest};
    _searchRequest.resellerCode = resellerCode + resellerName;
    giftService.getMyGiftEager(_searchRequest).then(res => {
      console.log("getMyGiftEager", res);
      import('xlsx').then(xlsx => {
        var excelList = [];
        res.forEach(a => {
          let _allGiftTransactionType = [...allGiftTransactionType];
          let _response = _allGiftTransactionType.find(gift => gift.key === a.giftTransactionType);

          excelList.push({
            "Talep Kodu": a.code,
            "Ürün Barkodu": a.gift?.barcode,
            "Ürün İsmi": a.gift?.name,
            "Satın Alan kişi": a.requester?.name + " " + a.requester?.surname,
            "Onay Durumu": _response?.value,
            "Ürün Puanı": a.gift?.giftScore,
          })
        });
        const worksheet = xlsx.utils.json_to_sheet(excelList);
        var wscols = [
          {width: 18},
          {width: 18},
          {width: 18},
          {width: 18},
          {width: 18},
          {width: 18},
          {width: 18},
          {width: 18},
          {width: 18},
          {width: 18},
          {width: 18}
        ];
        worksheet["!cols"] = wscols;
        const workbook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
        const excelBuffer = xlsx.write(workbook, {bookType: 'xlsx', type: 'array'});
        saveAsExcelFile(excelBuffer, 'Bayi Puan Hediyelerim Listesi');
      });
    }).catch(err => {
      toast?.current?.show({
        severity: 'error',
        summary: 'Hata',
        detail: 'İşlem bilgisi getirme başarısız.'
      });
      console.log(err);
    }).finally(() => {
      setExportExcelDisabled(false);
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import('file-saver').then(FileSaver => {
      let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
    });
  };

  return (
    <>
      <Toast ref={toast}/>


      <div className="datatable-responsive-demo">
        <br/>
        <br/>
        <div style={{paddingBottom: 20}}><Button label="Geri Dön" icon="pi pi-arrow-left"
                                                 className="p-button-outlined p-button-info"
                                                 onClick={e => history.push("giftTransaction")}/></div>
        <div className="p-d-flex p-ai-center export-buttons">
          <p style={{paddingLeft: 10,}}><b>Onaylı Harcanan Toplam Puan:{totalApproveScore}</b></p>

        </div>
        <div className="p-d-flex p-ai-center export-buttons">
          <p style={{paddingLeft: 10}}><b>Onayda Bekleyen Toplam Puan:{totalWaitingScore}</b></p>

      </div>
        <Button style={{marginLeft: 10}} label="Bayi Puan Hediyelerim Listesini İndir" type="button" icon="pi pi-file-excel" disabled={exportExcelDisabled}
                onClick={exportExcel} className="p-button-success p-mr-2" data-pr-tooltip="XLS"/>
        <ResponsiveDataTable value={allGifts}
                             loading={loading}
                             paginationConfig={paginationConfig}
                             onActivePageChange={onActivePageChange}
                             emptyMessage="Ürün Bulunamadı."
                             onSort={onSort}
                             sortField={searchRequest.sortField}
                             sortOrder={searchRequest.sortOrder}>
          <Column header="Talep Kodu" filter filterElement={codeFilter} field="code"/>
          <Column header="Ürün Barkodu" filter filterElement={barcodeFilter} field="gift.barcode"/>
          <Column header="Ürün İsmi" filter filterElement={nameFilter} field="gift.name"/>
          <Column header="Satın Alan kişi " filter filterElement={requesterFilter} field="requester.name"
                  body={e => requesterTemplate(e)}/>
          <Column header="Onay Durumu" filter filterElement={currentTypeFilter} field="giftTransactionType"
                  body={e => giftTransactionTemplate(e)}
          />
          <Column header="Ürün Puanı" field="gift.giftScore" sortable/>
          <Column header="Resimler" body={rowData => {
            return (<div><Button label="Resimler" className="p-button-text p-button"
                                 onClick={e => {
                                   setEditImages(rowData?.gift?.images)
                                   setViewImageDialog(true)
                                 }
                                 }/>
            </div>)
          }}/>


        </ResponsiveDataTable>

      </div>
      <Dialog style={{width: 500}} onHide={e => setViewImageDialog(false)} visible={viewImageDialog}
      >

        <ResponsiveDataTable emptyMessage="Kayıtlı Resim bulunamadı" header="Kayıtlı Resimler" value={editImages}>
          <Column header="Resim" body={imageTemplate} field="publicAddress"/>

        </ResponsiveDataTable>
      </Dialog>

    </>
  )
}
export default LastGiftView
